<script lang="ts">
  import { ethers } from 'ethers'
  import { parseUnits } from 'ethers/lib/utils'
  import { setContext } from 'svelte'
  import {Sale, SaleDurationInTimestamp} from "rain-sdk";
  import {calculatePriceConfig, canEndConfig} from "../contracts/sale";
  import NETWORKS from '../constants/network';
  import { formattedChainID } from '../utils';
  import { chainId } from 'svelte-ethers-store';
  import {getSigner} from "../contracts/utils/utils";

  const deploy = async (
    recipient: string,
    reserve: string,
    cooldownDuration: string,
    minimumRaise: string,
    price: string,
    name: string,
    symbol: string,
    initialSupply: string,
    walletCap: string,
    startTime: number,
    endTime: number,
    reserveErc20: object
  ) => {
    let signer = await getSigner()
    const newSale =  Sale.deploy(signer,
      {
        canStartStateConfig: new SaleDurationInTimestamp(startTime),
        canEndStateConfig: canEndConfig(endTime, minimumRaise, reserveErc20['erc20decimals']),
        calculatePriceStateConfig: calculatePriceConfig(price, reserveErc20['erc20decimals'], walletCap),
        recipient: recipient,
        reserve: reserve,
        saleTimeout: 10,
        cooldownDuration: parseInt(cooldownDuration.toString()),
        minimumRaise: parseUnits(
          minimumRaise.toString(),
          reserveErc20['erc20decimals'],
        ),
        dustSize: 0,
      },
      {
        erc20Config: {
          name: name,
          symbol: symbol,
          distributor: ethers.constants.AddressZero,
          initialSupply: parseUnits(initialSupply.toString()),
        },
        tier: NETWORKS[formattedChainID($chainId)].DEFAULT_VERIFY,
        minimumTier: 0,
        distributionEndForwardingAddress: ethers.constants.AddressZero,
      },
    )
      return newSale
  }
  setContext('saleDeploy', deploy)
</script>

<slot />
